import styled from "styled-components";

import type { ProWebsiteFeaturesLobsDtoLobSegmentData } from "@similarweb/pro-api-client";
import { colorsPalettes } from "@similarweb/styles";
import { CheckboxIcon, ListItemSegment } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

const { bluegrey } = colorsPalettes;

const ListItemWrapper = styled.div<{ $isChecked?: boolean; $isDisabled?: boolean }>`
    box-sizing: border-box;
    display: flex;
    align-items: center;
    background-color: ${({ $isChecked }) => ($isChecked ? bluegrey[100] : "transparent")};
    cursor: ${({ $isDisabled }) => ($isDisabled ? "default" : "pointer")};

    .ListItemSegment {
        flex: 1;
        padding-left: 14px;
        background-color: ${({ $isChecked }) => ($isChecked ? bluegrey[100] : "transparent")};
    }

    &:hover {
        background-color: ${({ $isChecked, $isDisabled }) => (!$isChecked && !$isDisabled ? bluegrey[200] : undefined)};

        .ListItemSegment {
            background-color: ${({ $isChecked, $isDisabled }) =>
                !$isChecked && !$isDisabled ? bluegrey[200] : undefined};
        }
    }
`;

interface ILobListItem {
    data: ProWebsiteFeaturesLobsDtoLobSegmentData;
    onClick: (item: ProWebsiteFeaturesLobsDtoLobSegmentData) => void;
    isChecked?: boolean;
    isMultiSelect?: boolean;
    isDisabled?: boolean;
}

export const LobListItem = ({ data, onClick, isChecked, isMultiSelect, isDisabled }: ILobListItem) => {
    const handleClick = () => onClick(data);

    return (
        <ListItemWrapper
            $isChecked={isChecked}
            $isDisabled={isDisabled}
            onClick={isDisabled ? undefined : handleClick}
            data-automation="LobListItem"
        >
            <ListItemSegment
                domainName={data.Site}
                segmentName={data.LobName}
                img={data.Favicon}
                isDisabled={isDisabled}
            />
            {isMultiSelect ? (
                <Flex
                    flexShrink={0}
                    padding="0 20px 0 0"
                >
                    <CheckboxIcon
                        disabled={isDisabled}
                        selected={isChecked}
                    />
                </Flex>
            ) : null}
        </ListItemWrapper>
    );
};
